export const DIVISIONS_FEATURE_KEY = 'divisions';
